const menu = {
    label: 'Usuários',
    icon: 'pi pi-fw pi-users',
    to: '/controleacesso/usuarios',
    rules: ['CTRLACS-USR-00'],
};

export default menu;
